import React, { ReactNode } from "react";
import { Stack } from "@mui/material";

export interface IPopupMenuProps {
  children: ReactNode;
  top?: string | number;
  right?: string | number;
}

export const PopupMenu = ({ children, top = 0, right = 0 }: IPopupMenuProps) => {
    return (
        <Stack
            direction="row"
            sx={{
                position: "absolute",
                top,
                right,
                backgroundColor: "background.paper",
                borderRadius: "20px",
                border: "1px solid",
                borderColor: "divider",
                zIndex: 1000,
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            {children}
        </Stack>
    );
};